// @flow
import React from 'react'
import Helmet from 'react-helmet'
import PageHeader from '../../components/PageHeader'
import FaqTabs from '../../components/FaqTabs'
import Card from '../../components/Card'

const KiefRealtyDifference = () => (
  <div>
    <Helmet title="Kief Realty Difference" />
    <PageHeader text="The Kief Realty Difference">
      Your satisfaction comes first.
      <br />
      <br />
      Any smart business would make this claim. But at Kief Realty, our business
      is a reflection of the people we are personally and professionally. We are
      good people wanting to work with and help other good people. We are not
      motivated to move you through the process quickly. We believe that if we
      invest the time and effort into helping you reach your goals, you&apos;ll
      want to work with us again in the future.
      <br />
      <br />
      We may be referred to as salespersons by default, but we are advisors and
      consultants at heart. Kief Realty is committed to provide you the support
      you need, from the beginning of your search to the moment you get the keys
      to your new home.
      <br />
      <br />
      When we say your satisfaction comes first, we mean it.
    </PageHeader>
    <FaqTabs />
    <div className="container">
      <Card style={{ margin: '2rem auto', maxWidth: '700px' }}>
        <h2>Buy With The Support of Kief Realty Experts</h2>
        <p>
          Working with Kief Realty means you receive tailored support and
          service from our team of experts. We provide homebuyers with a unique,
          modern, and efficient home buying experience.
        </p>
        <p>
          As a buyer, you get a dedicated Kief Realty team member who will make
          sure that your journey to your new home is as smooth and stress free
          as possible. We ensure that you have access to many support utilities
          including: education about the buying process, private home tours,
          market and value analysis, guidance on negotiation and availability
          for questions at any time.
        </p>
        <p>
          Because Kief Realty is made up of real estate experts working as a
          team, we take pride in our quick action. Our team advantage puts us in
          the position to provide fast, expert service to you. Plus we&apos;re
          just flat out fun to work with!
        </p>
      </Card>
      <Card style={{ margin: '2rem auto', maxWidth: '700px' }}>
        <h2>Transparent Buying Process</h2>
        <p>
          Trust. In a major financial decision like buying a home, having a
          trustworthy real estate professional in your corner is key. Through
          our online platform and dedicated team, you can feel confident that
          there will be no guessing, no grey areas, and absolutely no fluff.
        </p>
        <p>
          You get a thorough breakdown of your entire transaction, with status
          updates at every stage of the process. If any surprises or curveballs
          come our way, we will always openly discuss and work through them
          together.
        </p>
      </Card>
      <Card style={{ margin: '2rem auto', maxWidth: '700px' }}>
        <h2>Online Real Estate Platform</h2>
        <p>
          Kief Realty&apos;s objective is to cater to the adaptive industry and
          growing tech savvy consumer population by moving the home buying
          process online through our tools. Providing a process on the web makes
          home buying more pleasant, hassle free, and very transparent.
          Everything is documented and you can check the progress anytime.
        </p>
        <p>
          Going digital also ensures that we have the data to backup our advice.
          We help you reach informed conclusions and educated decisions by
          providing unbiased market data on demand.
        </p>
      </Card>
      <Card style={{ margin: '2rem auto', maxWidth: '700px' }}>
        <h2>No Strings Attached</h2>
        <p>
          We don&apos;t tie our clients down. We know that home buying is a
          major decision. If any particular home or even the decision to
          purchase turns out not to be in your best interest, you have the right
          to change your mind.
        </p>
        <p>
          The same principal applies to our agency relationships. If you have
          decided to hire Kief Realty and have consented to our Buyer Agency
          Agreement, but later decide to go another route... just say the word.
          We believe in a no-hassle agency relationship. We will promptly cancel
          any agency agreement upon your written request.
        </p>
      </Card>
    </div>
  </div>
)

export default KiefRealtyDifference



// WEBPACK FOOTER //
// ./src/views/KiefRealtyDifference/index.js